(function () {
  if (window.__scwCollectionRandomizerLoaded) return;
  window.__scwCollectionRandomizerLoaded = true;

  var GRID_SELECTOR = '#product-grid[data-scw-randomize="true"]';
  var HOME_GRID_SELECTOR = '[data-scw-randomize-home="true"]';
  var observer = null;
  var scheduled = false;

  function shuffle(items) {
    var shuffled = items.slice();

    for (var index = shuffled.length - 1; index > 0; index -= 1) {
      var randomIndex = Math.floor(Math.random() * (index + 1));
      var current = shuffled[index];
      shuffled[index] = shuffled[randomIndex];
      shuffled[randomIndex] = current;
    }

    return shuffled;
  }

  function randomizeGrid(grid) {
    if (!grid || grid.dataset.scwRandomized === 'true') return;

    var items = Array.prototype.slice.call(grid.children).filter(function (item) {
      return item.hasAttribute('data-scw-product-card');
    });
    if (items.length < 2) return;

    var availableItems = items.filter(function (item) {
      return item.dataset.scwProductAvailable === 'true';
    });
    var soldOutItems = items.filter(function (item) {
      return item.dataset.scwProductAvailable !== 'true';
    });

    grid.dataset.scwRandomized = 'true';

    var fragment = document.createDocumentFragment();
    shuffle(availableItems).concat(soldOutItems).forEach(function (item, index) {
      item.style.setProperty('--animation-order', index + 1);
      fragment.appendChild(item);
    });

    grid.appendChild(fragment);
  }

  function randomizeHomeGrid(grid) {
    if (!grid || grid.dataset.scwRandomized === 'true') return;

    var items = Array.prototype.slice.call(grid.children).filter(function (item) {
      return item.hasAttribute('data-scw-product-card');
    });
    if (items.length < 2) return;

    var visibleLimit = parseInt(grid.dataset.scwVisibleLimit, 10);
    if (!visibleLimit || visibleLimit < 1) visibleLimit = items.length;

    var availableItems = items.filter(function (item) {
      return item.dataset.scwProductAvailable === 'true';
    });

    grid.dataset.scwRandomized = 'true';

    var fragment = document.createDocumentFragment();
    shuffle(availableItems)
      .slice(0, visibleLimit)
      .forEach(function (item, index) {
        item.style.setProperty('--animation-order', index + 1);
        fragment.appendChild(item);
      });

    while (grid.firstChild) grid.removeChild(grid.firstChild);
    grid.appendChild(fragment);

    var sliderComponent = grid.closest('slider-component');
    if (sliderComponent && typeof sliderComponent.resetPages === 'function') {
      sliderComponent.resetPages();
    }
  }

  function randomizeHomeGrids() {
    Array.prototype.forEach.call(document.querySelectorAll(HOME_GRID_SELECTOR), randomizeHomeGrid);
  }

  function run() {
    scheduled = false;
    randomizeGrid(document.querySelector(GRID_SELECTOR));
    randomizeHomeGrids();
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(run);
    } else {
      window.setTimeout(run, 0);
    }
  }

  function observeGridContainer() {
    var container = document.getElementById('ProductGridContainer');

    if (observer) observer.disconnect();
    if (!container) {
      schedule();
      return;
    }

    observer = new MutationObserver(function (mutations) {
      var hasAddedNodes = mutations.some(function (mutation) {
        return mutation.addedNodes.length > 0;
      });

      if (hasAddedNodes) schedule();
    });

    observer.observe(container, { childList: true, subtree: true });
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeGridContainer);
  } else {
    observeGridContainer();
  }

  schedule();
  window.setTimeout(schedule, 150);
  window.setTimeout(schedule, 750);
  window.addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', observeGridContainer);
})();
